import { DeleteOutline } from "@mui/icons-material";
import {
    Collapse,
    TableCell,
    TableRow,
  } from "@mui/material";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { userStatuses } from "../../../app/config/userStatuses";
import {format} from "../../../utils/timeZoneUtils";

function translateRoles(input) {
    const roleMap = {
        "Administrator": "Admin",
        "Redaktor": "Editor",
        "Użytkownik": "User"
    };

    return input
        .split(",")
        .map(role => role.trim())
        .map(role => roleMap[role] || role)
        .join(", ");
}

function UsersTableRow({ open, user, onRowClick, onStatusChange, onDelete, isCurrentUserAdmin = false, before}) {
    const { t: t_button } = useTranslation('Buttons');
    const { t: t_link} = useTranslation('Pages');
    const { t: t_status } = useTranslation('UsersScreen', { keyPrefix: 'TableFilter.status' });

    const navigate = useNavigate();
    const statusText = _.find(
        userStatuses,
        (e) => e.value === user.isBlocked
      )?.text;

    return (
        <>
            <TableRow
                className={`row ${open ? " active" : ""}`}
            >
                <TableCell
                    padding="none"
                    className="fk-table-cell --first"
                    onClick={() => onRowClick(user.id)}
                >
                    <span className="value">{user.friendlyId}</span>
                </TableCell>
                <TableCell
                    padding="none"
                    className="fk-table-cell"
                    onClick={() => onRowClick(user.id)}
                >
                    <span className="value">{user.fullName}</span>
                </TableCell>
                <TableCell
                    padding="none"
                    className="fk-table-cell"
                    onClick={() => onRowClick(user.id)}
                >
                    <span className="value">{user.email}</span>
                </TableCell>
                <TableCell
                    padding="none"
                    className="fk-table-cell"
                    onClick={() => onRowClick(user.id)}
                >
                    <span className="value">{translateRoles(user.roles)}</span>
                </TableCell>
                <TableCell
                    padding="none"
                    className="fk-table-cell"
                    onClick={() => onRowClick(user.id)}
                >
                    <span className="value">
                        {format(user.createdAt)}
                    </span>
                </TableCell>
                <TableCell
                    padding="none"
                    className="fk-table-cell"
                    onClick={() => onRowClick(user.id)}
                >
                    <span className="value">{t_status(statusText)}</span>
                </TableCell>
                <TableCell padding="none" className="fk-table-cell crud --last">
                    <span className="value">
                        {/*<Block onClick={() => onStatusChange(user.id)} />*/}
                        {isCurrentUserAdmin &&
                        <DeleteOutline
                            onClick={() => onDelete(user)}
                        />
                        }
                        <button
                            className="show-details-button"
                            onClick={() => {
                                const base = t_link('userLink').replace(':id', user.id);
                                const url = before ? `${base}?before=${encodeURIComponent(before)}` : base;
                                navigate(url);
                            }}
                        >
                            {t_button('show')}
                        </button>
                    </span>
                </TableCell>
            </TableRow>
            {open &&
                <TableRow className="row collapsed-data">
                    <TableCell
                        className="fk-table-cell --first"
                        colSpan={7}
                    >
                        <Collapse in={open} timeout="auto" className="collapse">
                            {user.fullName}
                        </Collapse>
                    </TableCell>
                </TableRow>
            }

      </>
    );
}

export default connect(null, {})(UsersTableRow);
